const LEASING_COMPANY_GETTERS = {
  getLeasingCompanies: state => state.leasingCompanies,
  getError: state => state.status.error,
};

export default LEASING_COMPANY_GETTERS;
